module.exports = __webpack_public_path__ + "img/Partnership.f36b5563.svg";